module.exports = __webpack_public_path__ + "static/img/store5.5479a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/store5.jpg
// module id = SYjz
// module chunks = 1